module.exports = __webpack_public_path__ + "static/media/tl.aae61131.webp";